/* global dataLayer:true */
import $ from 'jquery';

// on doc ready we init all tag injecting functions
$(() => {
    tagNavSearch();
    tagHomeBannerSearch();
    tagMapSearch();
    tagPropertySearch();
    tagPropertyInterest();
    tagPropertyInterestOtherProjects();
    tagPropertyInterestConversion();
    tagPropertyInterestCta();
});

// Add GTM datalayer inject to top nav search (desktop and mobile)
function tagNavSearch() {
    const $searchForm = $('.c-desktop-submenu .search-form, .c-mobile-submenu .search-form');
    let searchInputVal = '';
    if (!$searchForm.length) { return; }

    // Handle the enter press on the search input
    $searchForm.find('.c-search-hinteded-input input').keypress(function (e) {
        if (e.which === 13) {
            searchInputVal = $(this).val();
        }
    });

    // Handle the search button click
    $searchForm.find('.btn-search').click(function () {
        const $localSearchForm = $(this).closest('.search-form');
        const searchType = $localSearchForm.find('select option:selected').text().trim();
        let searchValues = getActiveSearchValues($localSearchForm);
        if (searchInputVal) {
            searchValues = searchValues ? `${searchValues},${searchInputVal}` : searchInputVal;
        }
        pushDataLayer({
            event: 'Search',
            webSiteLocation: 'Navigation Search',
            searchAssetType: searchType,
            searchLocations: searchValues
        });
    });
}

// Add GTM datalayer inject to home page banner seach
function tagHomeBannerSearch() {
    const $searchForm = $('.s-search-banner .search-content');
    let searchInputVal = '';
    if (!$searchForm.length) { return; }

    // Handle the enter press on the search input
    $searchForm.find('.c-search-hinteded-input input').keypress(function (e) {
        if (e.which === 13) {
            searchInputVal = $(this).val();
        }
    });

    // Handle the search button click
    $searchForm.find('.btn-skin-3').click(function () {
        const $localSearchForm = $(this).closest('.search-content');
        let searchValues = getActiveSearchValues($localSearchForm);
        if (searchInputVal) {
            searchValues = searchValues ? `${searchValues},${searchInputVal}` : searchInputVal;
        }
        pushDataLayer({
            event: 'Search',
            webSiteLocation: 'Home Page Search',
            searchLocations: searchValues
        });
    });
}

// Add GTM datalayer inject to map seach
function tagMapSearch() {
    const $mapLinks = $('.map-pop .map-regions li a');
    if (!$mapLinks.length) { return; }

    $mapLinks.click(function () {
        pushDataLayer({
            event: 'Search',
            webSiteLocation: 'Map Search',
            searchLocations: $(this).text()
        });
    });
}

// Add GTM datalayer inject to property seach
function tagPropertySearch() {
    const $searchForm = $('.project-search-tool');
    let searchInputVal = '';
    if (!$searchForm.length) { return; }

    // Handle the enter press on the search input
    $searchForm.find('input.project-region').keypress(function (e) {
        if (e.which === 13) {
            searchInputVal = $(this).val();
        }
    });

    // Handle the search button click
    $('.project-search-tool .project-search-block button, .advanced-filters button').click(() => {
        // Get the search type and value
        const searchType = $searchForm.find('.nav-tabs li.active a') ? $searchForm.find('.nav-tabs li.active a').text().trim() : 'Apartment';
        let searchValues = getActiveSearchValues($searchForm);
        if (searchInputVal) {
            searchValues = searchValues ? `${searchValues},${searchInputVal}` : searchInputVal;
        }

        // Get the min / max value on price, bed and size
        const minPrice = $searchForm.find('#min-price').length ? $searchForm.find('#min-price').val() : 'Any';
        const maxPrice = $searchForm.find('#max-price').length ? $searchForm.find('#max-price').val() : 'Any';
        const minBed = searchType === 'Apartment' && $searchForm.find('#min-bed').length ? $searchForm.find('#min-bed').val() : 'Any';
        const maxBed = searchType === 'Apartment' && $searchForm.find('#max-bed').length ? $searchForm.find('#max-bed').val() : 'Any';
        const minSize = searchType === 'Land' && $searchForm.find('#min-size').length ? $searchForm.find('#min-size').val() : 'Any';
        const maxSize = searchType === 'Land' && $searchForm.find('#max-size').length ? $searchForm.find('#max-size').val() : 'Any';

        // Get the Advance filter values and sort / display values
        const listStyle = $('.sort-nav li.active').length ? $('.sort-nav li.active span').text().trim() : 'Grid';
        const sort = $('.sort-nav select').length ? $('.sort-nav select option:selected').text().trim() : 'Location';
        const landAdvanceFilters = searchType === 'Land' ? {
            frontage: $('.advanced-filters #frontage').length ? $('.advanced-filters #frontage').val().replace(',', '|') : '5|50',
            depth: $('.advanced-filters #depth').length ? $('.advanced-filters #depth').val().replace(',', '|') : '20|40'
        } : '';
        const apartmentAdvanceFilters = searchType === 'Apartment' ? {
            cars: $('.advanced-filters .adv-filter-car').length ? $('.advanced-filters .adv-filter-car option:selected').text().trim() : 'Any',
            'min size': $('.advanced-filters .adv-filter-min').length ? $('.advanced-filters .adv-filter-min option:selected').text().trim() : 'Any',
            'max size': $('.advanced-filters .adv-filter-max').length ? $('.advanced-filters .adv-filter-max option:selected').text().trim() : 'Any',
            'distance to cbd': $('.advanced-filters .adv-filter-distance').length ? $('.advanced-filters .adv-filter-distance option:selected').text().trim() : 'Any',
            'walk score': $('.advanced-filters .adv-filter-walk').length ? $('.advanced-filters .adv-filter-walk option:selected').text().trim() : 'Any',
            aspect: $('.advanced-filters .adv-filter-aspect').length ? $('.advanced-filters .adv-filter-aspect option:selected').text().trim() : 'Any',
            level: $('.advanced-filters .adv-filter-level').length ? $('.advanced-filters .adv-filter-level option:selected').text().trim() : 'Any'
        } : '';

        pushDataLayer({
            event: 'Search',
            webSiteLocation: 'Property Search',
            searchAssetType: searchType,
            searchLocations: searchValues,
            listStyle,
            sort,
            minPrice: minPrice ? minPrice : 'Any',
            maxPrice: maxPrice ? maxPrice : 'Any',
            minSize: minSize ? minSize : 'Any',
            maxSize: maxSize ? maxSize : 'Any',
            minBed: minBed ? minBed : 'Any',
            maxBed: maxBed ? maxBed : 'Any',
            landAdvanceFilters,
            apartmentAdvanceFilters
        });
    });
}

// Add GTM datalayer inject to property item click through on the search results page
function tagPropertyInterest() {
    const $searchResults = $('#search-results-page-results-holder');
    if (!$searchResults.length) { return; }

    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: true };

    // Create an observer instance linked to a callback function
    const observer = new MutationObserver(() => {
        // Attach datalayer push to cta of the tiles
        const $tiles = $searchResults.find('.development-sites-block, .angular-google-map .infobox');
        $tiles.each(function () {
            const propertyName = $(this).find('h5').text().trim();
            const $propertyLocationLi = $(this).find('.development-sites-content > ul > li:first-child');
            const propertyLocation = $propertyLocationLi.find('> span').length ? $propertyLocationLi.find('> span').first().text().trim() : $propertyLocationLi.text().trim();
            let propertyType = 'Apartment';
            if ($(this).hasClass('land-block')) {
                propertyType = 'Land';
            } else if ($(this).hasClass('infobox')) {
                // in the map view, we can only assume that tile without bedroom and price is a Land tile....
                const bedDisabled = $(this).find('.development-sites-content > ul > li:nth-child(2)').hasClass('ng-hide');
                const priceDisabled = $(this).find('.development-sites-content > ul > li:nth-child(3)').hasClass('ng-hide');
                if (bedDisabled && priceDisabled) {
                    propertyType = 'Land';
                }
            }

            $(this).find('a').click(() => {
                pushDataLayer({
                    event: 'Property Interest',
                    'conversion funnel': 'Viewed',
                    webSitelocation: 'Property Search',
                    propertyName,
                    propertyLocation,
                    propertyType
                });
            });
        });

        // Attach datalayer push to cta of the table entries
        const $entryRows = $searchResults.find('.table-pricelist tr.ng-scope');
        $entryRows.each(function () {
            const propertyName = $(this).find('> td:first-child > a').text().trim();
            const propertyLocation = $(this).find('> td:nth-child(2)').text().trim();
            const propertyType = $(this).find('> td:last-child').hasClass('ng-hide') ? 'Land' : 'Apartment';

            $(this).find('> td:first-child > a').click(() => {
                pushDataLayer({
                    event: 'Property Interest',
                    'conversion funnel': 'Viewed',
                    webSitelocation: 'Property Search',
                    propertyName,
                    propertyLocation,
                    propertyType
                });
            });
        });
    });

    // Start observing the target node for configured mutations
    observer.observe($searchResults.get(0), config);

    // Later, you can stop observing - but we never want to do this if we are on the search results page...
    // observer.disconnect();
}

// Add GTM datalayer inject to property item click through in the "Other projects" section
function tagPropertyInterestOtherProjects() {
    const $tiles = $('.development-sites-block');
    if (!$tiles.length) { return; }

    $tiles.each(function () {
        const propertyName = $(this).find('h5').text().trim();
        const propertyLocation = $(this).find('.development-sites-content > ul > li:first-child').text().trim();
        const propertyType = $(this).hasClass('land-block') ? 'Land' : 'Apartment';

        $(this).find('a').click(() => {
            pushDataLayer({
                event: 'Property Interest',
                'conversion funnel': 'Viewed',
                webSitelocation: 'Other Projects',
                propertyName,
                propertyLocation,
                propertyType
            });
        });
    });
}

// Add GTM datalayer inject to property details page enquire submit
function tagPropertyInterestConversion() {
    const $projectTitle = $('h1.title');
    const $projectDetails = $('.project-details');
    const $formTimeToBuy = $('#tfa_27');
    const $formBuyerType = $('#tfa_48');
    if (!$projectTitle.length || !$projectDetails.length || !$formTimeToBuy.length || !$formBuyerType.length) {
        return;
    }

    // Get the property details from online text...
    const propertyName = $projectTitle.text().trim();
    const propertyLocationMixed = $projectDetails.find('.project-details-location').length ? $projectDetails.find('.project-details-location').text().trim() : '';
    const propertyLocation = propertyLocationMixed.split(': ')[1];
    const propertyTypeMixed = $projectDetails.find('.project-details-type').length ? $projectDetails.find('.project-details-type').text().trim() : '';
    const propertyType = propertyTypeMixed.split(': ')[1];

    // Find the form submit button we are using
    $formTimeToBuy.closest('form').submit(() => {
        pushDataLayer({
            event: 'Property Interest',
            'conversion funnel': 'Conversion - Submit',
            propertyName,
            propertyLocation,
            propertyType,
            timeToPurchase: $formTimeToBuy.find('option:selected').text().trim(),
            buyerType: $formBuyerType.find('option:selected').text().trim()
        });
    });
}

//
//
//
//
// @NOTE!!!! We implmented the below due to mis-understanding on the tracking requirement
//           Thus, the below has been commented out
//
//
//
// Add GTM datalayer inject to generic property interest CTA click
// function tagPropertyInterestCta() {
//     const $interestLink = $('.property-interest-cta');
//     if (!$interestLink.length) { return; }

//     $interestLink.click(function () {
//         const propertyName = $(this).data('property-name');
//         const propertyLocation = $(this).data('property-location');
//         const propertyType = $(this).data('property-type');
//         const funnel = $(this).data('conversion-funnel');

//         pushDataLayer({
//             event: 'Property Interest',
//             'conversion funnel': funnel,
//             propertyName,
//             propertyLocation,
//             propertyType
//         });
//     });
// }

// Add GTM datalayer inject to generic property interest CTA click
function tagPropertyInterestCta() {
    const $interestLink = $('.property-interest-convert-cta');
    if (!$interestLink.length) { return; }

    $interestLink.click(function () {
        const propertyName = $(this).data('property-name');
        const propertyLocation = $(this).data('property-location');
        const propertyType = $(this).data('property-type');
        const funnel = $(this).data('conversion-funnel');

        pushDataLayer({
            event: 'Property Interest',
            'conversion funnel': funnel,
            propertyName,
            propertyLocation,
            propertyType
        });
    });
}

// Centralise the datalayer push code to help with debugging
// We also debounce the calls here to prevent double logging
let pushingData = [];
function pushDataLayer(data) {
    if (!containsObject(data, pushingData)) {
        pushingData.push(data);
    }

    // Debounce the call to make sure no duplicates are pushed
    setTimeout(() => {
        pushingData.forEach(dataItem => {
            console.log(dataItem);
            dataLayer.push(dataItem);
        });
        pushingData = [];
    }, 0);
}

// Check if the array contains the given object
function containsObject(obj, list) {
    let i;
    for (i = 0; i < list.length; i += 1) {
        if (list[i] === obj) {
            return true;
        }
    }

    return false;
}

// Look for the already activated search choices in the passed in search form
// Return a single string with all values joined with a comma
function getActiveSearchValues($searchForm) {
    const $searchValueElements = $searchForm.find('.project-region-choices .select-choice');
    const searchValues = [];
    $searchValueElements.each(function () {
        searchValues.push($(this)
            .clone()
            .children()
            .remove()
            .end()
            .text()
            .trim());
    });
    return searchValues.join(',');
}



// WEBPACK FOOTER //
// ./src/components/gtm-datalayer/c-gtm-datalayer.js